/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InspectionsSyncItemsResponse } from './InspectionsSyncItemsResponse';
import {
    InspectionsSyncItemsResponseFromJSON,
    InspectionsSyncItemsResponseFromJSONTyped,
    InspectionsSyncItemsResponseToJSON,
    InspectionsSyncItemsResponseToJSONTyped,
} from './InspectionsSyncItemsResponse';

/**
 * 
 * @export
 * @interface InspectionsSyncResponse
 */
export interface InspectionsSyncResponse {
    /**
     * 
     * @type {Date}
     * @memberof InspectionsSyncResponse
     */
    serverTimeUtc?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof InspectionsSyncResponse
     */
    isFullSync?: boolean;
    /**
     * 
     * @type {InspectionsSyncItemsResponse}
     * @memberof InspectionsSyncResponse
     */
    syncItems?: InspectionsSyncItemsResponse;
}

/**
 * Check if a given object implements the InspectionsSyncResponse interface.
 */
export function instanceOfInspectionsSyncResponse(value: object): value is InspectionsSyncResponse {
    return true;
}

export function InspectionsSyncResponseFromJSON(json: any): InspectionsSyncResponse {
    return InspectionsSyncResponseFromJSONTyped(json, false);
}

export function InspectionsSyncResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InspectionsSyncResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'serverTimeUtc': json['serverTimeUtc'] == null ? undefined : (new Date(json['serverTimeUtc'])),
        'isFullSync': json['isFullSync'] == null ? undefined : json['isFullSync'],
        'syncItems': json['syncItems'] == null ? undefined : InspectionsSyncItemsResponseFromJSON(json['syncItems']),
    };
}

export function InspectionsSyncResponseToJSON(json: any): InspectionsSyncResponse {
    return InspectionsSyncResponseToJSONTyped(json, false);
}

export function InspectionsSyncResponseToJSONTyped(value?: InspectionsSyncResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serverTimeUtc': value['serverTimeUtc'] == null ? undefined : ((value['serverTimeUtc']).toISOString()),
        'isFullSync': value['isFullSync'],
        'syncItems': InspectionsSyncItemsResponseToJSON(value['syncItems']),
    };
}

